if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);

				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				async function addExtraProducts(productIds, main_prod_id) {
					try {
						const requests = [];
						for (const productId of productIds) {
							const response = await fetch('/cart/add.js', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json'
								},
								body: JSON.stringify({
									quantity: 1,
									id: productId,
									properties: {
										'_main_prod_id': main_prod_id
									}
								})
							});
							const responseData = await response.json();
							requests.push(responseData);
						};
						await Promise.all(requests);
					} catch (error) {
						console.error('Error adding products:', error);
						throw error;
					}
				}

				async function fetchData(context) {
					try {
						const productIds = [];
						const additionalProducts = document.querySelectorAll('.additional-products');
						additionalProducts.forEach((element) => {
							if (element && element.tagName === 'SELECT' && element.value.trim() !== '') {
								var selectable = true;
							}
							const checkbox = element;
							if (checkbox && checkbox.checked || selectable == true && selectable != undefined) {
								const productId = element.value;
								if (productId) {
									productIds.push(productId);
								}
							}
						});
						
						if (productIds.length > 0) {
							await addExtraProducts(productIds, formData.get("id"));
						};
						
						fetch(`${routes.cart_add_url}`, config)
							.then((response) => response.json())
							.then((response) => {
								if (response.status) {
									publish(PUB_SUB_EVENTS.cartError, {
										source: "product-form",
										productVariantId: formData.get("id"),
										errors: response.description,
										message: response.message,
									});
									context.handleErrorMessage(response.description);

									const soldOutMessage =
										context.submitButton.querySelector(".sold-out-message");
									if (!soldOutMessage) return;
									context.submitButton.setAttribute("aria-disabled", true);
									context.submitButton.querySelector("span").classList.add("hidden");
									soldOutMessage.classList.remove("hidden");
									context.error = true;
									return;
								} else if (!context.cart) {
									window.location = window.routes.cart_url;
									return;
								}

								if (!context.error)
									publish(PUB_SUB_EVENTS.cartUpdate, {
										source: "product-form",
										productVariantId: formData.get("id"),
									});
								context.error = false;
								const quickAddModal = context.closest("quick-add-modal");
								console.log(context.cart);
								console.log('response', response);
								if (quickAddModal) {
									document.body.addEventListener(
										"modalClosed",
										() => {
											setTimeout(() => {
												context.cart.renderContents(response);
											});
										},
										{ once: true }
									);
									quickAddModal.hide(true);
								} else {
									context.cart.renderContents(response);
								}
							})
							.catch((e) => {
								console.error(e);
							})
							.finally(() => {
								context.submitButton.classList.remove("loading");
								if (context.cart && context.cart.classList.contains("is-empty"))
									context.cart.classList.remove("is-empty");
								if (!context.error) context.submitButton.removeAttribute("aria-disabled");
								//context.querySelector('.loading-overlay__spinner').classList.add('hidden');
							});
					} catch (err) {
						console.log(err)
					}
				}

				fetchData(this);
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
